module.exports = __webpack_public_path__ + "images/2f3272bed52a0637f01daef46ee82ba8.png";